<div class="home-container">
  <div class="text-center mb-5">
    <ng-container *ngIf="!isAuthenticated">
      <app-landing></app-landing>
    </ng-container>

  </div>

  <div *ngIf="isAuthenticated">
    <app-loading *ngIf="sessionService.isLoadingChangeRole" mensaje="Cambiando de rol..." />

    <div class="mt-4">
      <div class="text-center mb-4">
        <h1>Sistema de Salud Irrecuperable</h1>

        <p class="text-muted">{{ nombreUsuario }}</p>
      </div>

      <div class="tramites-grid">
        <div class="card home-card" *ngIf="!isEvaluado" (click)="navigateTo('/solicitud-salud-irrecuperable')"
          role="button">
          <div class="card-body text-center">
            <h5 class="card-title">Evaluación de Salud Irrecuperable de Funcionario Público</h5>
            <p class="card-text text-muted mt-3">Accede a la evaluación de salud irrecuperable de servidores públicos
            </p>
            <div class="mt-4">
              <i class="bi bi-file-earmark-check" style="font-size: 2.5rem; color: var(--primary);"></i>
            </div>
          </div>
        </div>



        <div class="card home-card" (click)="navigateTo('/documentos/presentacion-inicial')" role="button">
          <div class="card-body text-center">
            <h5 class="card-title">Carga de Documentos Inicial</h5>
            <p class="card-text text-muted mt-3">Sube los documentos necesarios para iniciar tu trámite</p>
            <div class="mt-4">
              <i class="bi bi-cloud-upload" style="font-size: 2.5rem; color: var(--primary);"></i>
            </div>
          </div>
        </div>

        <div class="card home-card" (click)="navigateTo('/documentos/apelacion')" role="button">
          <div class="card-body text-center">
            <h5 class="card-title">Apelación Resolución Evaluación Salud Irrecuperable de Funcionario Público</h5>
            <p class="card-text text-muted mt-3">Gestiona apelaciones y resoluciones de evaluaciones de salud
              irrecuperable</p>
            <div class="mt-4">
              <i class="bi bi-exclamation-circle" style="font-size: 2.5rem; color: var(--primary);"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>